import { render, staticRenderFns } from "./SSOEmbed.vue?vue&type=template&id=c1d137ec&scoped=true"
import script from "./SSOEmbed.vue?vue&type=script&lang=js"
export * from "./SSOEmbed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1d137ec",
  null
  
)

export default component.exports